import { SagaIterator } from 'redux-saga';
import { fork, takeLatest } from 'redux-saga/effects';
import { SearchActionTypes, ContentActionTypes } from '../actions/ActionTypes';
import { performSearchV2 } from './PerformSearchSaga';
import { requestContentSlice } from './RequestContentSliceSaga';
import { metricsDataSaga } from './MetricsDataSaga';

export function* searchResultSaga(): SagaIterator {
  yield takeLatest(SearchActionTypes.PERFORM_SEARCH, performSearchV2);
  yield takeLatest(ContentActionTypes.REQUEST, requestContentSlice);
  yield fork(metricsDataSaga);
}
